// AddressNameHelp.jsx — the help line under every delivery-address Name field.
// Its text is exactly ADDRESS_NAME_HELP_TEXT (src/services/addressName.ts), with the
// two cases in bold. Give the input aria-describedby={id} so screen readers read it.
export function AddressNameHelp({ id }) {
  return (
    <div id={id} className="text-[12px] leading-[1.45] text-[#3E5551] mt-[6px]">
      Prints on the delivery. <strong>Open address:</strong> the organisation's name.{" "}
      <strong>Confidential address:</strong> "Att:" then the primary contact or caseworker's name.
    </div>
  );
}
